"use strict";

(function(){
    /**
     *
     * @type {*}
     */
    var self = Fotobook.bottomPanel.fotosTab = {

        fotosContainerSelector: '.album-fotos',
        selectionTimeout: false,
        actionAdd: 1,
        actionRemove: 2,
        scrolled: 0,

        /**
         * Сортировка фотографий
         */
        sortFotos() {
            const id = Number($('#albums').val());
            if (id) {
                // if ($("html").hasClass("is-open-foto-panel")) {
                if (Fotobook.store.getters['imagesPanel/opened']) {
                    Fotobook.fotoManager.updatePhotocollectionPhotosList(id);
                } else {
                    Fotobook.fotoManager.imagesTab.sort();
                    Fotobook.store.dispatch('imagesPanel/draw');
                }
            }
        },

        /**
         * Отметить ассоциированную фотоколлекцию в выпадающем списке
         */
        markFotocollection(){
            var $albums = $('#albums.import-list');
            $albums.find("option").removeClass("marked-album");

            for (var i = 0; i < Fotobook.book.albums.length; i++) {
                if (!Fotobook.book.albums[i].parent_id && Fotobook.book.albums[i].project_id == Fotobook.book.project.id) {
                    $albums.find('option[value="' + Fotobook.book.albums[i].id + '"]').addClass('marked-album');
                    break;
                }
            }
        },

        removeImage(id){
            Fotobook.fotoManager.imagesTab.removeImage(id);

            // перерисовывается и без данной строки
            // Fotobook.store.dispatch('imagesPanel/draw');
        },
        /**
         * посчитать кол-во раз использования фото в проекте
         */
        countFotoInProject(id){
            return $(Fotobook.book.pagesList).find(".foto-image.foto_" + id + ', .bg-clipart-foto[data-id="' + id + '"]').length;
        },

        deselectImage(id){
            id = parseInt(id, 10);
            clearTimeout(this.selectionTimeout);
            if (!this.countFotoInProject(id)) {
                Fotobook.fotoManager.imagesTab.updateImageAttrs(id, {selected: false});
                $(this.fotosContainerSelector).find('.album_image[data-id="' + id + '"]').closest('.outer').removeClass('selected');
            }
            this.selectionTimeout = setTimeout(this.showNumberOfPhotos, 100);
        },
// управление типом отображения фото в нижнеей панели - одна/две линии

        /**
         * @link https://jsfiddle.net/mywmzona/zzveprg5/
         * @param id
         * @param action
         */
        rebuild2Lines(id, action){
            if (Fotobook.$cookies.get('fotos-two-line') === 'false') {
                return;
            }
            var albumFotos = $('.album-fotos'),
                foto = Fotobook.fotoManager.imagesTab.getImage(id),
                item = '';
            if (!$('#hide_used').prop('checked') || !albumFotos.hasClass('two-lines')) {
                return;
            }
            switch (action) {
                case Fotobook.bottomPanel.actionAdd:
                    albumFotos.find('.foto_' + id).closest('.outer').remove();
                    self.compareLines();
                    break;
                case Fotobook.bottomPanel.actionRemove:
                    if (foto && !albumFotos.find('.two-lines-items .foto_' + id).length) {
                        item = self.getItemStr(foto);
                        albumFotos.find('.first-line').find('.spacer').before(item);
                        self.compareLines();
                    }
                    break;
                default:
                    break;
            }
        },

        compareLines(){
            var $albumPhotos = $('.album-fotos'),
                $firstLine = $albumPhotos.find('.first-line'),
                $firstLineItems = $firstLine.find('.album_image'),
                $secondLine = $albumPhotos.find('.second-line'),
                $secondLineItems = $secondLine.find('.album_image');

            if (($firstLineItems.length - $secondLineItems.length) > 1) {
                self.moveItem2Line($firstLineItems, $secondLine);
            } else if (($secondLineItems.length - $firstLineItems.length) > 1) {
                self.moveItem2Line($secondLineItems, $firstLine);
            }
        },

        moveItem2Line(from, to){
            to.find('.spacer').before(from[from.length - 1].closest('.outer'));
        },
///////////////////////
        updateImageAttrs(id, attrs){
            Fotobook.fotoManager.imagesTab.updateImageAttrs(id, attrs);
            $(this.fotosContainerSelector).find(".album_image.foto_" + id).attr({
                "src": Fotobook.book.getFotoPath(attrs),
                "data-w": attrs.width,
                "data-h": attrs.height,
            });
        },

        checkHideUsedVisibility(){
            var id = parseInt($("#albums").val(), 10),
                show = false;
            if (id) {
                for (var i = 0; i < Fotobook.book.albums.length; i++) {
                    if (Fotobook.book.albums[i].id === id) {
                        show = Fotobook.book.albums[i].project_id === Fotobook.book.project.id;
                        break;
                    }
                }
            }
            Fotobook.store.dispatch('imagesPanel/setHideUsedItemsVisible', show);
        },

/********    следующие три функции пересмотреть и унифицировать ******/
         selectImage(id){
             id = parseInt(id, 10);
             clearTimeout(this.selectionTimeout);
             Fotobook.fotoManager.imagesTab.updateImageAttrs(id, {selected: true});
             $(this.fotosContainerSelector).find('.album_image[data-id="' + id + '"]').closest('.outer').addClass('selected');
             this.selectionTimeout = setTimeout(this.showNumberOfPhotos, 100);
         },

        /** Отметить использованые в проектке фото */
        markUsedPhotos(){
            var usedPhotos = $(Fotobook.book.pagesList + ' .foto-image:not([data-id=""])');
            $.each(usedPhotos, function (key, val) {
                self.selectImage($(this).attr("data-id"));
                $(this).attr("deselect-foto-id", $(this).attr("data-id")); // используем data, чтобы эти данные не попадали в .html()
                self.rebuild2Lines($(this).attr("data-id"), Fotobook.bottomPanel.actionAdd);
            });
        },

        /** пометить фото развернутой панели */
        markSelectedPhotos(){
            $.each($('.photocollection-photos-list').find('.image'), function () {
                var self = $(this),
                    id = self.attr('data-id'),
                    // не выбирать каждый раз - смотри markUsedPhotos
                    usedPhoto = $(Fotobook.book.pagesList)
                        .find('image.foto-image[data-id="' + id + '"], .bg-clipart-foto[data-id="' + id + '"]');
                if (usedPhoto.length) {
                    self.closest('li').addClass('selected');
                }
            });
        },

        /**
         * Посчитать число используемых фотографий на табе "Фото"
         */
        countUsedPhotos() {
            const found = {};
            $(Fotobook.book.pagesList).find('image.foto-image:not([data-id=""]),.bg-clipart-foto').each(function () {
                const id = this.getAttribute('data-id');
                if (id) {
                    found[id] = true;
                }
            });

            return Object.keys(found).length;
        },

        /**
         * Показать на панели кол-во использованых в проекте фото
         */
        showNumberOfPhotos() {
            const numberOfPhotos = self.countUsedPhotos();
            $('#num-pics span').text(numberOfPhotos);
        },
    };
})();
